import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { startNewSucursal, startSaveSucursal, sucursalStartDelete } from '../../../actions/sucursales';
import { openModalBottom } from '../../../actions/ui';
import { ArrowBackIcon, TrashIcon } from '../../../assets/svg/iconos'
import { camposIntegracionParaGuardar, esRolPlataforma } from '../../../helpers/camposIntegracion';
import { datafonosDeSucursal, RESOLUCION_ERROR, RESOLUCION_RESUELTA, sucursalesPorDatafono } from '../../../helpers/cobroDatafono';
import { newSucursal } from '../../../helpers/helpers';
import { useComercioPosms } from '../../../hooks/useComercioPosms';
import { useDatafonosSucursal } from '../../../hooks/useDatafonosSucursal';
import { AvatarProfesional } from './AvatarProfesional';
import { DatafonosSucursal, datafonosParaGuardar } from './DatafonosSucursal';
import { Festivos } from './Festivos';
import { ModalEliminarSucursal } from './modales/ModalEliminarSucursal';
import { Semanal } from './Semanal';
import { Vacacional } from './Vacacional';

/**
 * EX-614: la asociación de datáfonos no entra en el efecto de `cambiado`, que compara propiedad a
 * propiedad con `!==` y daría siempre cambiada una lista (dos arrays nunca son el mismo objeto).
 * Sus cambios se detectan aparte, contra la línea base con la que se cargó la pantalla.
 */
const hayCambiosEnDatafonos = (datafonos, originales) => {
    if (datafonos.length !== originales.length) return true;
    return datafonos.some((datafono, indice) => {
        const original = originales[indice];
        return datafono.deviceId !== original.deviceId
            || (datafono.nombre || '') !== (original.nombre || '')
            || !!datafono.activo !== !!original.activo
            || !!datafono.predeterminado !== !!original.predeterminado;
    });
};

export const Sucursal = ({ history }) => {

    const dispatch = useDispatch();
    
    const { profesionales } = useSelector(state => state.profesionales);
    const { colores, miniLateral } = useSelector(state => state.ui);
    const { empresa, role } = useSelector(state => state.auth);

    // EX-619: el comercio POSMS y el Merchant Id son datos de integración que administra la
    // plataforma, no el comercio. Un rol de negocio no los ve ni los manda al guardar.
    const puedeVerIntegracion = esRolPlataforma( role );

    const [currentSucursal, setCurrentSucursal] = useState( history.location.state.sucursal || undefined );
    const [currentScreen] = useState( (history.location.state.sucursal !== 'new') ? 'edit' : 'new' );

    const [objSucursal, setObjSucursal] = useState({});
    const [iniciado, setIniciado] = useState(false);
    const [cambiado, setCambiado] = useState(false);

    // EX-614: los datáfonos asociados salen del endpoint autenticado del POS, el mismo que decide
    // el enrutado del cobro, y NUNCA de `objSucursal`: al store lo puebla un endpoint público que
    // no proyecta `datafonos`, así que al recargar la página la asociación se perdía de vista.
    //
    // Se lee también en una sucursal nueva, aunque no tenga asociación propia que recuperar: es
    // lo que dice qué terminales están ya en otro mostrador, y sin ello la pantalla de creación
    // los ofrecería todos como libres.
    const { resolucion: resolucionDatafonos, sucursales: sucursalesConDatafonos, reintentar } = useDatafonosSucursal( true );

    const [datafonos, setDatafonos] = useState([]);
    const [datafonosOriginales, setDatafonosOriginales] = useState([]);

    // EX-619: el comercio no llega con la sucursal del store —su endpoint es público y no lo
    // proyecta—, así que se lee aparte y se guarda en su propio estado. Fuera de `objSucursal` a
    // propósito: el efecto de `cambiado` compara esa ficha contra la que se cargó, y un campo que
    // aparece después daría la sucursal por modificada nada más abrirla.
    // Un alta todavía no tiene `_id` y no hay nada que leer: el hook resuelve con el comercio
    // vacío en vez de pedirlo.
    const {
        resolucion: resolucionComercio,
        comercio: comercioGuardado,
        reintentar: reintentarComercio,
    } = useComercioPosms(
        objSucursal?._id || null,
        puedeVerIntegracion
    );
    const comercioResuelto = resolucionComercio === RESOLUCION_RESUELTA;
    const [comercio, setComercio] = useState('');
    const [comercioOriginal, setComercioOriginal] = useState('');

    const [activeTab, setActiveTab] = useState( 'semanal' );

    const [editMode, setEditMode] = useState(true); 
    
    // const [idiomaActive, setIdiomaActive] = useState('ES');
    const [objErrores, setObjErrores] = useState({});  
    const [profs, setProfs] = useState([]);

    const [modalEliminarSucursalOpened, setModalEliminarSucursalOpened] = useState(false);
    const [dataModalEliminar, setDataModalEliminar] = useState({
        title: '¿Eliminar sucursal?',
        text: [],
        buttonText: 'Eliminar',
        button2Text: 'Cancelar'
    });

    useEffect(() => {
      if( currentSucursal !== 'new' ){
        // console.log( currentSucursal );
        setObjSucursal( currentSucursal );
        setIniciado( true );
      } else {
        // console.log( 'nueva' );
        setEditMode( true );
        setCambiado(true);
        const nuevo = newSucursal( empresa );
        setCurrentSucursal( nuevo );
        setObjSucursal( nuevo );
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentSucursal]);

    useEffect(() => {
        // console.log( 'objSucursal', objSucursal );
        if( currentSucursal ){
            const servicioOriginal = { ...currentSucursal };
            if( iniciado ){
                let igual = true;
                const todasPropiedades = new Set([...Object.keys(servicioOriginal), ...Object.keys(objSucursal)]);
                for( const propiedad of todasPropiedades ){
                    if( servicioOriginal[propiedad] !== objSucursal[propiedad] ){
                    igual = false;
                    console.log(`Cambio en ${propiedad}`);
                    }
                }
                setCambiado( !igual );
            }
        }
    }, [iniciado, currentSucursal, objSucursal]);

    // EX-614: la asociación se siembra cuando la configuración se resuelve, y con ella la línea
    // base contra la que se sabe si el usuario ha cambiado algo. Un reintento vuelve a sembrarla.
    useEffect(() => {
        if( resolucionDatafonos !== RESOLUCION_RESUELTA ) return;
        // Una sucursal nueva no está en la respuesta y el helper devuelve la lista vacía sola.
        const asociados = datafonosDeSucursal( sucursalesConDatafonos, objSucursal?._id );
        setDatafonos( asociados );
        setDatafonosOriginales( asociados );
    }, [resolucionDatafonos, sucursalesConDatafonos, objSucursal?._id]);

    // EX-619: el comercio se siembra cuando su lectura se resuelve, con su línea base, igual que
    // la asociación de datáfonos. Hasta entonces el campo queda vacío pero la sección de datáfonos
    // no lo toma por "sin comercio": para eso mira la resolución, no el valor.
    useEffect(() => {
        if( resolucionComercio !== RESOLUCION_RESUELTA ) return;
        setComercio( comercioGuardado );
        setComercioOriginal( comercioGuardado );
    }, [resolucionComercio, comercioGuardado]);

    useEffect(() => {
        setProfs(
            profesionales.filter( prof => {
                return prof.sucursales.includes( currentSucursal._id ) && !prof.deleted;
            })
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profesionales]);    
    

    const backClick = (e) => {
      e.preventDefault();
      history.push({ pathname: `/sucursales` });
    }

    const cancelar = () => {
        console.log( currentScreen );
        if( currentScreen !== 'new' ){
            setObjSucursal( currentSucursal );
            setDatafonos( datafonosOriginales );
            setComercio( comercioOriginal );
        } else {
            history.goBack();
        }
    }
    
    const onFormChange = (e) => {
        let correcto = true;
        if( e.target.name === 'precio' ){
            const validNumber = new RegExp(/^\d*\.?\d*$/);
            if( !validNumber.test( e.target.value ) ){
                correcto = false;
            }
        }
        if( correcto ){
            dataChange( e.target.name, e.target.value );
        }
    }

    const dataChange = (name, value) => {
        if( editMode ){
            setObjSucursal({
                ...objSucursal,
                [name]: value
            });
        } else {
            dispatch( openModalBottom({text: ['Debes activar la edición para poder realizar cambios'], timeOut: 3}) );
        }
    }

    /**
     * EX-619: el comercio no pasa por `dataChange` porque no vive en `objSucursal`, pero respeta
     * el mismo modo de edición que el resto de campos de la ficha.
     */
    const cambiarComercio = ( valor ) => {
        if( !editMode ){
            dispatch( openModalBottom({text: ['Debes activar la edición para poder realizar cambios'], timeOut: 3}) );
            return;
        }
        setComercio( valor );
    }

    const changeHorario = ( newHorario ) => {
        setObjSucursal({
            ...objSucursal,
            horarioTxt: newHorario
        });
    }

    const guardar = () => {
        // console.log( 'currentScreen', currentScreen );
        let correcto = true;
        const newObjErrores = {};
        if( objSucursal?.nombre.trim() === '' ){ 
            correcto = false;
            newObjErrores.nombre = 'Debe escribir un nombre';
        }
        
        //console.log( objServicio );
        //console.log('Correcto:', correcto );
        //console.log('Errores:', newObjErrores );
        setObjErrores( newObjErrores );
        // EX-614: sin la configuración de datáfonos resuelta el payload sale sin la clave, para no
        // borrar con un `$set` una asociación que la pantalla no ha llegado a leer.
        let newObjeto = datafonosParaGuardar( objSucursal, { resolucion: resolucionDatafonos, datafonos } );
        // EX-619: el comercio y la asociación viajan en el mismo cuerpo, que es el camino normal
        // de la primera vez: el backend decide sobre `datafonos` con el comercio resultante del
        // guardado, así que configurar el comercio y marcar terminales es una sola pasada.
        newObjeto = camposIntegracionParaGuardar( newObjeto, { role, comercio, comercioResuelto } );
        if( correcto ){
            //console.log('correcto');            
            if( currentScreen === 'new' ){
                console.log( 'start new' );
                dispatch( startNewSucursal( newObjeto ) );
                history.push({ pathname: `/sucursales` });
            } else {
                console.log( 'start save' );
                newObjeto.empresa = empresa;
                dispatch( startSaveSucursal( newObjeto ) );
                setCambiado( false );
                setDatafonosOriginales( datafonos );
                setComercioOriginal( comercio );
                /* setObjServicio( newObjeto );
                setCurrentServicio( newObjeto ); */
            }

            
        } else {
            console.log( newObjErrores );
        }
    }

    const deleteSucursalModal = () => {
        setDataModalEliminar({
            ...dataModalEliminar,
            text: [`¿Estás seguro de que deseas eliminar la sucursal ${objSucursal?.nombre}?`]
        })
        setModalEliminarSucursalOpened( true );
    };

    const deleteSucursalResponse = ( value ) => {
        if( value === 1 ){
          console.log( 'value = 1' );
          let selectedId = objSucursal?._id;

          console.log( 'Borrar id:', selectedId );
          dispatch( sucursalStartDelete( selectedId, empresa ) );
          history.push({ pathname: `/sucursales` })
        }
    }

    // EX-614: la asociación de datáfonos ya no es una propiedad de `objSucursal`, así que los
    // botones de guardar y cancelar tienen que mirar también sus cambios.
    // EX-619: el comercio vive fuera de `objSucursal`, así que su cambio se detecta aparte, igual
    // que el de la asociación de datáfonos.
    const hayCambiosPendientes = cambiado
        || hayCambiosEnDatafonos( datafonos, datafonosOriginales )
        || comercio !== comercioOriginal;

    // EX-614: un datáfono está en un mostrador y solo en uno, así que el que ya tenga otra
    // sucursal no se ofrece aquí como disponible.
    const asignadosEnOtrasSucursales = sucursalesPorDatafono( sucursalesConDatafonos, objSucursal?._id );

    return (
        <>
        <div 
            className='sucursal'
            style={{
                '--colorPrincipal': colores.colorPrincipal,
                '--colorSecundario': colores.colorSecundario,
                '--color3': colores.color3,
                '--color4': colores.color4,
                '--color5': colores.color5,
                '--color6': colores.color6,
                '--color7': colores.color7,
            }}
        >
            <div className='sucursal-wrapper'>
                <div className='single-sucursal'>
                    <div className={`header ${!miniLateral && 'compress'}`}>
                        <div 
                            className='nav-back'
                            onClick={ (e) =>  backClick(e) }
                        >
                            <ArrowBackIcon color={ colores.colorSecundario } />
                            <p style={{ color: colores.colorSecundario }}>Sucursales</p>
                        </div>

                        <div className='botonera'>
                            {/* {
                                !cambiado &&
                                <button
                                    className='btn-mini btn-editar'
                                    style={{ backgroundColor: editMode ? colores.colorPrincipal : colores.color6 }}
                                    onClick={ () => setEditMode( !editMode ) }
                                >
                                    <EditarIcon color={ editMode ? colores.color6 : colores.colorPrincipal } />
                                </button>
                            } */}
                            {
                                !hayCambiosPendientes &&
                                <button
                                    className='btn-mini btn-eliminar'
                                    style={{ backgroundColor: colores.color6 }}
                                    onClick={ deleteSucursalModal }
                                >
                                    <TrashIcon color={ colores.colorPrincipal } />
                                </button>
                            }
                            {
                            hayCambiosPendientes &&
                                <button 
                                    className='btn btn-crear'
                                    style={{ backgroundColor: colores.colorPrincipal }}
                                    onClick={ guardar }
                                >
                                    {`${currentScreen === 'new' ? 'Crear' : 'Guardar'}`}
                                </button>
                            }
                            {
                            hayCambiosPendientes &&
                                <button 
                                    className='btn btn-cancelar'
                                    style={{ color: colores.colorPrincipal, backgroundColor: colores.color6 }}
                                    onClick={ cancelar }
                                >
                                    Cancelar
                                </button>
                            }
                        </div>
                    </div>
                    <div className='sucursal-body'>
                        <h1>
                            <input
                                style={{ 
                                    backgroundColor: editMode ? '#ffffff' : 'transparent',
                                    border: `${objErrores.nombre ? '2px solid ' + colores.color5 : 'none'}`
                                }}
                                autoComplete='off'
                                type="text"
                                placeholder='Introduzca nombre'
                                name="nombre"
                                disabled={ !editMode }
                                value={ objSucursal?.nombre || '' }
                                onChange={ (e) => onFormChange( e )}
                            />
                        </h1>
                        <div className='sucursal-main'>
                            <div className='map'>
                                <div className='bg-map'></div>
                                <iframe title="Mapa" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" src={`https://www.openstreetmap.org/export/embed.html?bbox=${ objSucursal?.long }%2C${ objSucursal?.lat }%2C${ objSucursal?.long }%2C${ objSucursal?.lat }&amp;layer=mapnik`}></iframe>
                            </div>
                            <div className='data'>
                                <div className='contacto-sucursal'>
                                    <h3 style={{ color: colores.colorSecundario }}>Datos de contacto</h3>
                                    <div className='address'>
                                        <input
                                            style={{ 
                                                backgroundColor: editMode ? '#ffffff' : 'transparent',
                                                border: `${objErrores.direccion ? '2px solid ' + colores.color5 : 'none'}`
                                            }}
                                            autoComplete='off'
                                            type="text"
                                            placeholder='Introduzca dirección'
                                            name="direccion"
                                            disabled={ !editMode }
                                            value={ objSucursal?.direccion || '' }
                                            onChange={ (e) => onFormChange( e )}
                                        />
                                    </div>
                                    <div className='city'>
                                        <input
                                            style={{
                                                backgroundColor: editMode ? '#ffffff' : 'transparent',
                                                border: `${objErrores.poblacion ? '2px solid ' + colores.color5 : 'none'}`
                                            }}
                                            autoComplete='off'
                                            type="text"
                                            placeholder='Introduzca población'
                                            name="poblacion"
                                            disabled={ !editMode }
                                            value={ objSucursal?.poblacion || '' }
                                            onChange={ (e) => onFormChange( e )}
                                        />
                                    </div>
                                    <div className='cp'>
                                        Código postal:
                                        <input
                                            style={{
                                                backgroundColor: editMode ? '#ffffff' : 'transparent',
                                                border: 'none'
                                            }}
                                            autoComplete='off'
                                            type="text"
                                            placeholder='Introduzca código postal'
                                            name="cp"
                                            disabled={ !editMode }
                                            value={ objSucursal?.cp || '' }
                                            onChange={ (e) => onFormChange( e )}
                                        />
                                    </div>
                                    <div className='razon-social'>
                                        Nombre / Razón social:
                                        <input
                                            style={{
                                                backgroundColor: editMode ? '#ffffff' : 'transparent',
                                                border: 'none'
                                            }}
                                            autoComplete='off'
                                            type="text"
                                            placeholder='Introduzca nombre o razón social'
                                            name="razonSocial"
                                            disabled={ !editMode }
                                            value={ objSucursal?.razonSocial || '' }
                                            onChange={ (e) => onFormChange( e )}
                                        />
                                    </div>
                                    <div className='cif'>
                                        CIF/NIF:
                                        <input
                                            style={{
                                                backgroundColor: editMode ? '#ffffff' : 'transparent',
                                                border: 'none'
                                            }}
                                            autoComplete='off'
                                            type="text"
                                            placeholder='Introduzca CIF/NIF'
                                            name="cif"
                                            disabled={ !editMode }
                                            value={ objSucursal?.cif || '' }
                                            onChange={ (e) => onFormChange( e )}
                                        />
                                    </div>
                                    <div className='razon-social'>
                                        Razón social:
                                        <input
                                            style={{
                                                backgroundColor: editMode ? '#ffffff' : 'transparent',
                                                border: 'none'
                                            }}
                                            autoComplete='off'
                                            type="text"
                                            placeholder='Introduzca razón social'
                                            name="razonSocial"
                                            disabled={ !editMode }
                                            value={ objSucursal?.razonSocial || '' }
                                            onChange={ (e) => onFormChange( e )}
                                        />
                                    </div>
                                    <div className='telephone'>
                                        Teléfono de contacto:
                                        <input
                                            style={{ 
                                                backgroundColor: editMode ? '#ffffff' : 'transparent',
                                                border: `${objErrores.poblacion ? '2px solid ' + colores.color5 : 'none'}`
                                            }}
                                            autoComplete='off'
                                            type="text"
                                            placeholder='Introduzca teléfono'
                                            name="telefono"
                                            disabled={ !editMode }
                                            value={ objSucursal?.telefono || '' }
                                            onChange={ (e) => onFormChange( e )}
                                        />
                                    </div>
                                    <div className='email'>
                                        Dirección de correo electrónico: 
                                        <input
                                            style={{ 
                                                backgroundColor: editMode ? '#ffffff' : 'transparent',
                                                border: `${objErrores.poblacion ? '2px solid ' + colores.color5 : 'none'}`
                                            }}
                                            autoComplete='off'
                                            type="email"
                                            placeholder='Sin e-mail'
                                            name="email"
                                            disabled={ !editMode }
                                            value={ objSucursal?.email || '' }
                                            onChange={ (e) => onFormChange( e )}
                                        />
                                    </div>
                                    <div className='latitud'>
                                        Latitud GPS:
                                        <input
                                            style={{ 
                                                backgroundColor: editMode ? '#ffffff' : 'transparent',
                                                border: `${objErrores.latitud ? '2px solid ' + colores.color5 : 'none'}`
                                            }}
                                            autoComplete='off'
                                            type="text"
                                            placeholder='Introduzca latitud GPS'
                                            name="lat"
                                            disabled={ !editMode }
                                            value={ objSucursal?.lat || '' }
                                            onChange={ (e) => onFormChange( e )}
                                        />
                                    </div>
                                    <div className='longitud'>
                                        Longitud GPS:
                                        <input
                                            style={{ 
                                                backgroundColor: editMode ? '#ffffff' : 'transparent',
                                                border: `${objErrores.longitud ? '2px solid ' + colores.color5 : 'none'}`
                                            }}
                                            autoComplete='off'
                                            type="text"
                                            placeholder='Introduzca longitud GPS'
                                            name="long"
                                            disabled={ !editMode }
                                            value={ objSucursal?.long || '' }
                                            onChange={ (e) => onFormChange( e )}
                                        />
                                    </div>
                                    {/* EX-619: los dos identificadores de integración. Las etiquetas
                                        los distinguen a propósito: el Merchant Id es el del pago
                                        online (un número) y el comercio POSMS el de los datáfonos
                                        (un UUID), y confundirlos no da ningún error visible, solo
                                        una sucursal que no cobra. Ninguno se pinta para un rol de
                                        negocio: los administra la plataforma. */}
                                    { puedeVerIntegracion && (
                                        <div className='longitud'>
                                            Merchant Id (pago online):
                                            <input
                                                style={{
                                                    backgroundColor: editMode ? '#ffffff' : 'transparent',
                                                    border: `'2px solid ' + colores.color5`
                                                }}
                                                autoComplete='off'
                                                type="text"
                                                placeholder='Código comercio del pago online'
                                                name="merchantId"
                                                disabled={ !editMode }
                                                value={ objSucursal?.merchantId || '' }
                                                onChange={ (e) => onFormChange( e )}
                                            />
                                        </div>
                                    )}
                                    { puedeVerIntegracion && (
                                        <div className='longitud'>
                                            Comercio POSMS (datáfonos):
                                            <input
                                                style={{
                                                    backgroundColor: editMode ? '#ffffff' : 'transparent',
                                                    border: `'2px solid ' + colores.color5`
                                                }}
                                                autoComplete='off'
                                                type="text"
                                                placeholder='UUID del comercio de datáfonos'
                                                name="posmsMerchantUuid"
                                                disabled={ !editMode }
                                                value={ comercio }
                                                onChange={ (e) => cambiarComercio( e.target.value )}
                                            />
                                        </div>
                                    )}
                                </div>
                                <DatafonosSucursal
                                    datafonos={ datafonos }
                                    asignadosEnOtras={ asignadosEnOtrasSucursales }
                                    resolucion={ resolucionDatafonos }
                                    reintentar={ reintentar }
                                    editMode={ editMode }
                                    onChange={ setDatafonos }
                                    comercio={ comercio }
                                    comercioPendiente={ !comercioResuelto }
                                    comercioNoLeido={ resolucionComercio === RESOLUCION_ERROR }
                                    reintentarComercio={ reintentarComercio }
                                    comercioGestionado={ puedeVerIntegracion }
                                    sucursalId={ objSucursal?._id || null }
                                />
                                <div className='profesionales-sucursal'>
                                    <h3 style={{ color: colores.colorSecundario }}>Profesionales</h3>
                                    <div className='profesionals-row'>
                                        {
                                            profs.map( prof => (
                                                <AvatarProfesional
                                                    key={ prof._id }
                                                    prof={ prof }
                                                    clase={ `prof-item` }
                                                />
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <h3 className='rotulo' style={{ color: colores.colorSecundario }}>Horarios</h3>
                        <div className='sucursal-tabs'>
                            <div 
                                className={ `sucursal-tab ${ activeTab === 'semanal' && 'active' }` }
                                style={{ 
                                    color: colores.colorPrincipal,
                                    backgroundColor: activeTab === 'semanal' ? colores.colorSecundario : colores.color6
                                }}
                                onClick= { () => setActiveTab('semanal') }
                            >
                                <span className='tab-icon'></span>
                                <p>Semanal</p>
                            </div>                            
                            <div 
                                className={ `sucursal-tab ${ activeTab === 'vacacional' && 'active' }` }
                                style={{ 
                                    color: colores.colorPrincipal,
                                    backgroundColor: activeTab === 'vacacional' ? colores.colorSecundario : colores.color6
                                }}
                                onClick= { () => setActiveTab('vacacional') }
                            >
                                <span className='tab-icon'></span>
                                <p>Periodo vacacional</p>
                            </div>                            
                            <div 
                                className={ `sucursal-tab ${ activeTab === 'festivos' && 'active' }` }
                                style={{ 
                                    color: colores.colorPrincipal,
                                    backgroundColor: activeTab === 'festivos' ? colores.colorSecundario : colores.color6
                                }}
                                onClick= { () => setActiveTab('festivos') }
                            >
                                <span className='tab-icon'></span>
                                <p>Festivos</p>
                            </div>                            
                        </div>
                        <div className='sucursal-secondary'>
                            {
                                activeTab === 'semanal' &&
                                <Semanal
                                    editMode={ editMode }
                                    horario={ objSucursal?.horarioTxt }
                                    changeHorario={ changeHorario }
                                />
                            }
                            {
                                activeTab === 'vacacional' &&
                                <Vacacional
                                    editMode={ editMode }
                                    sucursal={ objSucursal }
                                />
                            }
                            {
                                activeTab === 'festivos' &&
                                <Festivos
                                    editMode={ editMode }
                                    sucursal={ objSucursal }
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalEliminarSucursal
            data = { dataModalEliminar }
            setModalResponse = { deleteSucursalResponse }
            modalOpened = { modalEliminarSucursalOpened }
            setModalOpened = { setModalEliminarSucursalOpened }
        />
        </>
    )
}
